import { DownloadOutlined, ArrowLeftOutlined, SaveOutlined, EditOutlined, SearchOutlined, SendOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { ContentHeader } from "../../components";
import { layDsBaoHiem, layDsBaoHiemTheoNam } from '../../services/baohiem';
import { toast } from "react-toastify";
import { Button, Col, Form, Input, Row, Select, Space, Table, Tabs, DatePicker, Divider, Tag, InputNumber, Popconfirm, AutoComplete } from "antd";
import { formatVND, dateCommon, validateMessages } from '../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useNavigate } from 'react-router-dom';
import { Links } from '../../helpers/Links';
import { XuatExcelBaoCaoThueTNCN, capNhatDuLieuThamChieuThueThang, duyetThueThang, layChiTietThueTNCNThang, layDsThueThangTheoNam, layThongTinThueThang, luuThueThang, taiThueThang } from '../../services/thue';
import ModalTextForm from '../../components/modal/ModalTextForm';
import dayjs, { Dayjs } from 'dayjs';
import { ChiTietThueThangItem, DanhSachThueThangResponse, ThueThangInfo } from '../../models/thue/Thue';
import { DanhSachKhenThuongUngHoResponse } from '../../models/luong/Luong';
import { layDsBangLuongPhuCapTheoNam, layDsKhenThuongUngHoTheoNam, layDsLuongBoSungTruongBKSTheoNam, layDsLuongCoBanTheoNam, layDsLuongHoanThanhNhiemVuTheoNam, layDsLuongThemGioTheoNam, layDsPhuCapTGVTheoNam, layDsPhatSinhTinhThueTheoNam } from '../../services/luong';
import { layDsThuLaoKCT, layDsThuLaoKCTTheoNam } from '../../services/thulaokhongchuyentrach';
import { layDanhMucNhomNhanSu } from '../../services/danhmuc';
import { layDanhSachNhanSuKhac } from '../../services/nhansukhac';
import { NhanSuKhac } from '../../models/nhansukhac/NhanSuKhac';
import { BaoHiem } from '../../models/baohiem/BaoHiem';
import { kieuTinhThue, loaiChuKyThue } from '../../constants';

const ThueTNCN = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [formNhanSuNgoai] = Form.useForm();

    const [idThue, setIdThue] = useState<number>(0);
    const [thueThangInfo, setThueThangInfo] = useState<ThueThangInfo | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');
    const [isShowModalDuyet, setIsShowModalDuyet] = useState<boolean>(false);
    const [isShowModalCapNhatThamChieu, setIsShowModalCapNhatThamChieu] = useState<boolean>(false);
    const [isShowModalNhanSuNgoai, setIsShowModalNhanSuNgoai] = useState<boolean>(false);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [dsNhanSuKhac, setDsNhanSuKhac] = useState<Array<NhanSuKhac>>([]);
    const [dsNhomNhanSu, setDsNhomNhanSu] = useState<Array<any>>([]);

    const [danhSachChiTiet, setDanhSachChiTiet] = useState<Array<ChiTietThueThangItem>>([]);
    const [danhSachHienThi, setDanhSachHienThi] = useState<Array<ChiTietThueThangItem>>([]);

    // States cho từng thành phần
    const [dsLuongTangThem, setDsLuongTangThem] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsLuongCoBan, setDsLuongCoBan] = useState<Array<any>>([]);
    const [dsLuongPhuCap, setDsLuongPhuCap] = useState<Array<any>>([]);
    const [dsLuongThemGio, setDsLuongThemGio] = useState<Array<any>>([]);
    const [dsLuongHTNV, setDsLuongHTNV] = useState<Array<any>>([]);
    const [dsLuongBSTBKS, setDsLuongBSTBKS] = useState<Array<any>>([]);
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsBHXH, setDsBHXH] = useState<Array<any>>([]);
    const [dsLuongGiamTru, setDsLuongGiamTru] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [dsThueTamTinh, setDsThueTamTinh] = useState<Array<DanhSachThueThangResponse>>([]);
    const [dsPhatSinhThuNhap, setDsPhatSinhThuNhap] = useState<Array<any>>([]);
    const [dsPhatSinhGiamTru, setDsPhatSinhGiamTru] = useState<Array<any>>([]);

    // State namLoc cho từng thành phần
    const [namLocLuongTangThem, setNamLocLuongTangThem] = useState<Dayjs | null>(null);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCap, setNamLocLuongPhuCap] = useState<Dayjs | null>(null);
    const [namLocLuongThemGio, setNamLocLuongThemGio] = useState<Dayjs | null>(null);
    const [namLocLuongHTNV, setNamLocLuongHTNV] = useState<Dayjs | null>(null);
    const [namLocLuongBSTBKS, setNamLocLuongBSTBKS] = useState<Dayjs | null>(null);
    const [namLocLuongThuLaoKCT, setNamLocLuongThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocLuongPhuCapTGV, setNamLocLuongPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocBHXH, setNamLocBHXH] = useState<Dayjs | null>(null);
    const [namLocLuongGiamTru, setNamLocLuongGiamTru] = useState<Dayjs | null>(null);
    const [namLocThueTamTinh, setNamLocThueTamTinh] = useState<Dayjs | null>(null);
    const [namLocPhatSinhThuNhap, setNamLocPhatSinhThuNhap] = useState<Dayjs | null>(null);
    const [namLocPhatSinhGiamTru, setNamLocPhatSinhGiamTru] = useState<Dayjs | null>(null);

    const setChiTiet = (data: ChiTietThueThangItem[]) => {
        setDanhSachChiTiet(data);
        setDanhSachHienThi(data);
    };

    const layThongTin = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            const info = await layThongTinThueThang(id);
            setThueThangInfo(info);
            const chiTiet = await layChiTietThueTNCNThang(id);
            setChiTiet(chiTiet ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleTinhThue = async () => {
        dispatch(showLoadingScreen());
        try {
            const data = await taiThueThang(idThue);
            setChiTiet(data ?? []);
            toast.success('Tính thuế thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuThueThang({ id: idThue, chiTiet: danhSachChiTiet });
            toast.success('Lưu thuế thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleDuyet = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetThueThang(idThue);
            toast.success('Xác nhận thuế thành công');
            setIsShowModalDuyet(false);
            layThongTin(idThue);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    // Helper lấy ds từng thành phần theo năm
    const layDsThanhPhan = async (
        setFn: (data: any[]) => void,
        fetchFn: (nam?: number) => Promise<any[]>,
        nam?: number
    ) => {
        try {
            const data = await fetchFn(nam);
            setFn(data ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    // Helper tạo handler đổi năm lọc
    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        setListFn: React.Dispatch<React.SetStateAction<any[]>>,
        fetchFn: (nam?: number) => Promise<any[]>,
        filterFn?: (item: any) => boolean
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        try {
            const rawData = await fetchFn(date ? date.year() : undefined);
            const filteredData = filterFn ? (rawData ?? []).filter(filterFn) : (rawData ?? []);
            const currentSelected = form.getFieldValue(fieldName);
            const selectedIds: number[] = Array.isArray(currentSelected)
                ? currentSelected
                : (currentSelected != null ? [currentSelected] : []);
            const selectedSet = new Set(selectedIds);

            setListFn(prevList => {
                const map = new Map<number, any>();
                filteredData.forEach(item => {
                    if (item && item.id != null) map.set(item.id, item);
                });
                (prevList ?? []).forEach(item => {
                    if (item && item.id != null && selectedSet.has(item.id) && !map.has(item.id)) {
                        map.set(item.id, item);
                    }
                });
                return Array.from(map.values());
            });
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const onMoModalCapNhatThamChieu = async () => {
        setNamLocLuongTangThem(null);
        setNamLocLuongCoBan(null);
        setNamLocLuongPhuCap(null);
        setNamLocLuongThemGio(null);
        setNamLocLuongHTNV(null);
        setNamLocLuongBSTBKS(null);
        setNamLocLuongThuLaoKCT(null);
        setNamLocLuongPhuCapTGV(null);
        setNamLocBHXH(null);
        setNamLocLuongGiamTru(null);
        setNamLocThueTamTinh(null);
        setNamLocPhatSinhThuNhap(null);
        setNamLocPhatSinhGiamTru(null);

        dispatch(showLoadingScreen());
        try {
            const [rawKTUH, rawPSTT] = await Promise.all([
                layDsKhenThuongUngHoTheoNam(undefined),
                layDsPhatSinhTinhThueTheoNam(undefined),
                layDsThanhPhan(setDsLuongCoBan, layDsLuongCoBanTheoNam, undefined),
                layDsThanhPhan(setDsLuongPhuCap, layDsBangLuongPhuCapTheoNam, undefined),
                layDsThanhPhan(setDsLuongThemGio, layDsLuongThemGioTheoNam, undefined),
                layDsThanhPhan(setDsLuongHTNV, layDsLuongHoanThanhNhiemVuTheoNam, undefined),
                layDsThanhPhan(setDsLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam, undefined),
                layDsThanhPhan(setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam, undefined),
                layDsThanhPhan(setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam, undefined),
                layDsThanhPhan(setDsBHXH, layDsBaoHiemTheoNam, undefined),
                layDsThanhPhan(setDsThueTamTinh, layDsThueThangTheoNam, undefined),
            ]);

            const rawTangThem = (rawKTUH ?? []).filter(x => x.loai === 1);
            const rawGiamTru = (rawKTUH ?? []).filter(x => x.loai === 0);
            const rawPSTN = (rawPSTT ?? []).filter((x: any) => x.loai === 1);
            const rawPSGT = (rawPSTT ?? []).filter((x: any) => x.loai === 0);

            setDsLuongTangThem(rawTangThem);
            setDsLuongGiamTru(rawGiamTru);
            setDsPhatSinhThuNhap(rawPSTN);
            setDsPhatSinhGiamTru(rawPSGT);

            const dsIdKhenThuong = thueThangInfo?.dsIdLuongKhenThuongUngHo ?? [];
            const dsIdPhatSinh = thueThangInfo?.dsIdPhatSinhTinhThue ?? [];

            const setTangThemIds = new Set(rawTangThem.map(x => x.id));
            const setGiamTruIds = new Set(rawGiamTru.map(x => x.id));
            const setPSTNIds = new Set(rawPSTN.map(x => x.id));
            const setPSGTIds = new Set(rawPSGT.map(x => x.id));

            const selectedTangThem = dsIdKhenThuong.filter(id => setTangThemIds.has(id));
            const selectedGiamTru = dsIdKhenThuong.filter(id => setGiamTruIds.has(id));
            const selectedPSTN = dsIdPhatSinh.filter(id => setPSTNIds.has(id));
            const selectedPSGT = dsIdPhatSinh.filter(id => setPSGTIds.has(id));

            form.setFieldsValue({
                dsIdLuongTangThem: selectedTangThem,
                dsIdLuongGiamTru: selectedGiamTru,
                dsIdPhatSinhThuNhap: selectedPSTN,
                dsIdPhatSinhGiamTru: selectedPSGT,
                dsIdLuongCoBan: thueThangInfo?.dsIdLuongCoBan ?? [],
                dsIdLuongPhuCap: thueThangInfo?.dsIdLuongPhuCap ?? [],
                dsIdLuongThemGio: thueThangInfo?.dsIdLuongThemGio ?? [],
                dsIdLuongHTNV: thueThangInfo?.dsIdLuongHTNV ?? [],
                dsIdLuongBSTBKS: thueThangInfo?.dsIdLuongBSTBKS ?? [],
                dsIdLuongThuLaoKCT: thueThangInfo?.dsIdLuongThuLaoKCT ?? [],
                dsIdLuongPhuCapTGV: thueThangInfo?.dsIdLuongPhuCapTGV ?? [],
                dsIdBHXH: thueThangInfo?.dsIdBHXH ?? [],
                idThueTamTinh: thueThangInfo?.idThueTamTinh,
                dsIdThueTamTinh: thueThangInfo?.dsIdThueTamTinh ?? [],
            });

            setIsShowModalCapNhatThamChieu(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    const onFinishCapNhatThamChieu = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const dsIdLuongKhenThuongUngHo = [
                ...(values?.dsIdLuongTangThem ?? []),
                ...(values?.dsIdLuongGiamTru ?? []),
            ];

            const dsIdPhatSinhTinhThue = [
                ...(values?.dsIdPhatSinhThuNhap ?? []),
                ...(values?.dsIdPhatSinhGiamTru ?? []),
            ];

            const request = {
                id: idThue,
                idThueTamTinh: values.idThueTamTinh,
                dsIdLuongKhenThuongUngHo: dsIdLuongKhenThuongUngHo as number[],
                dsIdLuongCoBan: (values?.dsIdLuongCoBan ?? []) as number[],
                dsIdLuongPhuCap: (values?.dsIdLuongPhuCap ?? []) as number[],
                dsIdLuongThemGio: (values?.dsIdLuongThemGio ?? []) as number[],
                dsIdLuongHTNV: (values?.dsIdLuongHTNV ?? []) as number[],
                dsIdLuongBSTBKS: (values?.dsIdLuongBSTBKS ?? []) as number[],
                dsIdLuongThuLaoKCT: (values?.dsIdLuongThuLaoKCT ?? []) as number[],
                dsIdLuongPhuCapTGV: (values?.dsIdLuongPhuCapTGV ?? []) as number[],
                dsIdBHXH: (values?.dsIdBHXH ?? []) as number[],
                dsIdThueTamTinh: (values?.dsIdThueTamTinh ?? []) as number[],
                dsIdPhatSinhTinhThue: dsIdPhatSinhTinhThue as number[],
            };
            await capNhatDuLieuThamChieuThueThang(request);
            toast.success('Cập nhật dữ liệu tham chiếu thành công!');
            setIsShowModalCapNhatThamChieu(false);
            await layThongTin(idThue);
            await handleTinhThue();
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();
        setDanhSachHienThi(
            danhSachChiTiet.filter(
                x => kw.length === 0 ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw)
            )
        );
    };

    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            const response = await XuatExcelBaoCaoThueTNCN(idThue);
            let link = document.createElement('a');
            link.download = `ThueTNCN.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }
        dispatch(hideLoadingScreen());
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = parseInt(params.get('id') || '0');
        if (id > 0) setIdThue(id);
    }, []);

    useEffect(() => {
        if (idThue > 0) layThongTin(idThue);
    }, [idThue]);

    useEffect(() => {
        const loadDanhMuc = async () => {
            try {
                const [nsk, nhom] = await Promise.all([
                    layDanhSachNhanSuKhac(),
                    layDanhMucNhomNhanSu(),
                ]);
                setDsNhanSuKhac(nsk ?? []);
                setDsNhomNhanSu(nhom ?? []);
            } catch (e) {
                // ignore
            }
        };
        loadDanhMuc();
    }, []);

    const isDaDuyet = (thueThangInfo?.trangThai ?? 0) === 3;
    const soThang = thueThangInfo?.loaiChuKy === loaiChuKyThue.quy ? 3 : 1;

    const tinhThueTNCNPhaiNop = (thuNhapTinhThue: number, st: number) => {
        if (thuNhapTinhThue <= 0) return 0;
        if (thuNhapTinhThue <= 10000000 * st) return Math.round(thuNhapTinhThue * 0.05);
        if (thuNhapTinhThue <= 30000000 * st) return Math.round(thuNhapTinhThue * 0.10 - 500000 * st);
        if (thuNhapTinhThue <= 60000000 * st) return Math.round(thuNhapTinhThue * 0.20 - 3500000 * st);
        if (thuNhapTinhThue <= 100000000 * st) return Math.round(thuNhapTinhThue * 0.30 - 9500000 * st);
        return Math.round(thuNhapTinhThue * 0.35 - 14500000 * st);
    };

    const recalculateModalFields = (changedValues: any, allValues: any) => {
        const st = soThang;
        let soNPT = allValues.soNguoiPhuThuoc ?? 0;
        let giamTruBanThan = allValues.giamTruBanThan ?? 0;
        let giamTruNPT = allValues.giamTruNguoiPhuThuoc ?? 0;
        let giamTruKhac = allValues.giamTruKhac ?? 0;
        let thuNhapChiuThue = allValues.thuNhapChiuThue ?? 0;
        let thueDaNop = allValues.thueDaNop ?? 0;

        if ('soNguoiPhuThuoc' in changedValues) {
            giamTruNPT = soNPT * 6200000 * st;
        }

        const tongCongGiamTru = (giamTruBanThan || 0) + (giamTruNPT || 0) + (giamTruKhac || 0);
        const thuNhapTinhThue = Math.max(0, (thuNhapChiuThue || 0) - tongCongGiamTru);
        const thuePhaiNop = Math.round(tinhThueTNCNPhaiNop(thuNhapTinhThue, st));
        const thueConPhaiNop = Math.max(0, thuePhaiNop - (thueDaNop || 0));

        let newValues: any = {
            giamTruNguoiPhuThuoc: giamTruNPT,
            tongCongGiamTru,
            thuNhapTinhThue,
            thuePhaiNop,
            thueConPhaiNop,
        };

        if ('thuNhapChiuThue' in changedValues && !('thuNhapTraChoCaNhan' in changedValues)) {
            newValues.thuNhapTraChoCaNhan = thuNhapChiuThue;
        }

        formNhanSuNgoai.setFieldsValue(newValues);
    };

    const onMoModalThemNhanSu = () => {
        const st = soThang;
        setEditingIndex(null);
        formNhanSuNgoai.resetFields();
        formNhanSuNgoai.setFieldsValue({
            hoTen: '',
            tenChucVu: '',
            idNhom: 6,
            thuNhapChiuThue: 0,
            giamTruBanThan: 15500000 * st,
            soNguoiPhuThuoc: 0,
            giamTruNguoiPhuThuoc: 0,
            giamTruKhac: 0,
            tongCongGiamTru: 15500000 * st,
            thuNhapTraChoCaNhan: 0,
            thuNhapTinhThue: 0,
            thuePhaiNop: 0,
            thueDaNop: 0,
            thueConPhaiNop: 0,
            ghiChu: '',
        });
        setIsShowModalNhanSuNgoai(true);
    };

    const onMoModalSuaNhanSu = (record: ChiTietThueThangItem, index: number) => {
        setEditingIndex(index);
        formNhanSuNgoai.resetFields();

        const banThan = record.giamTruBanThan ?? 0;
        const npt = record.giamTruNguoiPhuThuoc ?? 0;
        const tongGT = record.tongCongGiamTru ?? 0;
        const giamTruKhac = Math.max(0, tongGT - banThan - npt);

        formNhanSuNgoai.setFieldsValue({
            hoTen: record.hoTen,
            tenChucVu: record.tenChucVu,
            idNhom: record.idNhom || 6,
            thuNhapChiuThue: record.thuNhapChiuThue ?? 0,
            giamTruBanThan: banThan,
            soNguoiPhuThuoc: record.soNguoiPhuThuoc ?? 0,
            giamTruNguoiPhuThuoc: npt,
            giamTruKhac: giamTruKhac,
            tongCongGiamTru: tongGT,
            thuNhapTraChoCaNhan: record.thuNhapTraChoCaNhan ?? record.thuNhapChiuThue ?? 0,
            thuNhapTinhThue: record.thuNhapTinhThue ?? 0,
            thuePhaiNop: record.thuePhaiNop ?? 0,
            thueDaNop: record.thueDaNop ?? 0,
            thueConPhaiNop: record.thueConPhaiNop ?? 0,
            ghiChu: record.ghiChu ?? '',
        });
        setIsShowModalNhanSuNgoai(true);
    };

    const onFinishNhanSuNgoai = (values: any) => {
        const nhomSelected = dsNhomNhanSu.find(n => n.id === values.idNhom);
        const tenNhom = nhomSelected?.ten || (values.idNhom === 6 ? 'Khác' : '');

        const nskSelected = dsNhanSuKhac.find(x => x.hoTen === values.hoTen);

        if (editingIndex !== null && editingIndex >= 0) {
            const updatedList = [...danhSachChiTiet];
            const target = updatedList[editingIndex];
            if (target) {
                const idNhanVien = (target.idNhanVien && target.idNhanVien > 0)
                    ? target.idNhanVien
                    : (nskSelected ? nskSelected.id : (target.idNhanVien || 0));
                const ma = target.ma || (nskSelected ? nskSelected.ma : (values.ma || ''));

                updatedList[editingIndex] = {
                    ...target,
                    idNhanVien: idNhanVien,
                    ma: ma,
                    hoTen: values.hoTen,
                    tenChucVu: values.tenChucVu || '',
                    idNhom: values.idNhom || 6,
                    tenNhom: tenNhom,
                    thuNhapChiuThue: values.thuNhapChiuThue || 0,
                    giamTruBanThan: values.giamTruBanThan || 0,
                    giamTruNguoiPhuThuoc: values.giamTruNguoiPhuThuoc || 0,
                    soNguoiPhuThuoc: values.soNguoiPhuThuoc || 0,
                    tongCongGiamTru: values.tongCongGiamTru || 0,
                    thuNhapTraChoCaNhan: values.thuNhapTraChoCaNhan || 0,
                    thuNhapTinhThue: values.thuNhapTinhThue || 0,
                    thuePhaiNop: values.thuePhaiNop || 0,
                    thueDaNop: values.thueDaNop || 0,
                    thueConPhaiNop: values.thueConPhaiNop || 0,
                    ghiChu: values.ghiChu || '',
                };
                setChiTiet(updatedList);
                toast.success('Cập nhật thông tin nhân sự thành công');
            }
        } else {
            const idNhanVien = nskSelected ? nskSelected.id : (values.idNhanVien || 0);
            const ma = nskSelected ? nskSelected.ma : (values.ma || '');

            const newItem: ChiTietThueThangItem = {
                id: 0,
                idThueThang: idThue,
                loaiNhanSu: 2,
                idNhanVien: idNhanVien,
                idChucVu: nskSelected?.idChucVu || 0,
                idDonVi: 0,
                tenChucVu: values.tenChucVu || '',
                tenDonVi: '',
                idNhom: values.idNhom || 6,
                tenNhom: tenNhom,
                ma: ma,
                hoTen: values.hoTen,
                thuNhapChiuThue: values.thuNhapChiuThue || 0,
                giamTruBanThan: values.giamTruBanThan || 0,
                giamTruNguoiPhuThuoc: values.giamTruNguoiPhuThuoc || 0,
                soNguoiPhuThuoc: values.soNguoiPhuThuoc || 0,
                tongCongGiamTru: values.tongCongGiamTru || 0,
                thuNhapTraChoCaNhan: values.thuNhapTraChoCaNhan || 0,
                thuNhapTinhThue: values.thuNhapTinhThue || 0,
                thuePhaiNop: values.thuePhaiNop || 0,
                thueDaNop: values.thueDaNop || 0,
                thueConPhaiNop: values.thueConPhaiNop || 0,
                ghiChu: values.ghiChu || '',
                dynamicColumns: {},
            };
            const updatedList = [...danhSachChiTiet, newItem];
            setChiTiet(updatedList);
            toast.success('Thêm nhân sự khác thành công');
        }
        setIsShowModalNhanSuNgoai(false);
    };

    const handleXoaNhanSu = (index: number) => {
        const updatedList = danhSachChiTiet.filter((_, i) => i !== index);
        setChiTiet(updatedList);
        toast.success('Xóa nhân sự thành công');
    };

    const demSoKhoan = (ids?: number[]) =>
        (ids?.length ?? 0) > 0 ? `${ids!.length} khoản` : 'Không có';

    // Helper render row chọn thành phần trong modal
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[]
    ) => (
        <Row gutter={8}>
            <Col span={8}>
                <Form.Item label={`Năm ${label}`}>
                    <DatePicker
                        changeOnBlur={true}
                        picker="year"
                        placeholder="Năm (để trống = tất cả)"
                        style={{ width: "100%" }}
                        value={namLoc}
                        onChange={onChangeNam}
                    />
                </Form.Item>
            </Col>
            <Col span={16}>
                <Form.Item label={label} name={fieldName}>
                    <Select
                        mode="multiple"
                        allowClear
                        placeholder={`Chọn ${label.toLowerCase()}`}
                        options={options}
                        notFoundContent="Không có dữ liệu"
                        filterOption={(input, option: any) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
            </Col>
        </Row>
    );

    const optionsLuongTangThem = dsLuongTangThem.map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` }));
    const optionsLuongGiamTru = dsLuongGiamTru.map(x => ({ value: x.id, label: `${x.ten} (${x.thoiGian})` }));
    const optionsPhatSinhThuNhap = dsPhatSinhThuNhap.map(x => ({ value: x.id, label: `${x.ten} (${dayjs(x.thangNam).format('MM/YYYY')})` }));
    const optionsPhatSinhGiamTru = dsPhatSinhGiamTru.map(x => ({ value: x.id, label: `${x.ten} (${dayjs(x.thangNam).format('MM/YYYY')})` }));
    const optionsLuongCoBan = dsLuongCoBan.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongPhuCap = dsLuongPhuCap.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThemGio = dsLuongThemGio.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongHTNV = dsLuongHTNV.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongBSTBKS = dsLuongBSTBKS.map(x => ({ value: x.id, label: x.tenKyLuong }));
    const optionsLuongThuLaoKCT = dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten }));
    const optionsLuongPhuCapTGV = dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten }));
    const optionsBaoHiem = (dsBHXH || []).map((x: BaoHiem) => ({
        value: x.id,
        label: `Tháng ${dayjs(x.thangNam).format('MM/YYYY')}${x.loaiBaoHiemThang === 1 ? ' - Bổ sung/Điều chỉnh' : ''}`,
    }));
    const optionsThueTamTinh = dsThueTamTinh.map(x => ({ value: x.id, label: x.tenKyThue }));
    const optionsNhanSuKhac = (dsNhanSuKhac || []).map(x => ({
        value: x.hoTen,
        label: `${x.hoTen}${x.tenChucVu ? ` (${x.tenChucVu})` : ''}`,
        item: x,
    }));
    const optionsNhomNhanSu = (dsNhomNhanSu && dsNhomNhanSu.length > 0)
        ? dsNhomNhanSu.map(x => ({ value: x.id, label: x.ten }))
        : [
            { value: 6, label: 'Khác' },
            { value: 1, label: 'Người lao động' },
            { value: 2, label: 'Người quản lý không chuyên trách' },
            { value: 3, label: 'Người quản lý' },
            { value: 5, label: 'Tổ giúp việc HĐQL' },
            { value: 7, label: 'Trưởng Ban kiểm soát' },
        ];

    return (
        <section>
            <ContentHeader title="Thuế TNCN" />

            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Nhập tên, mã nhân viên"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={(e) => { if (e.key === 'Enter') search(); }}
                    />
                </Col>
                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>
                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>Tìm kiếm</Button>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" className="hrm-btn hrm-btn-warning" icon={<ArrowLeftOutlined />} onClick={() => navigate(Links.Luong.QuanTriTinhThue)}>
                            Quay lại
                        </Button>
                        {!isDaDuyet && (
                            <Button type="primary" icon={<DownloadOutlined />} onClick={handleTinhThue}>Tính thuế</Button>
                        )}
                        {!isDaDuyet && (
                            <Button type="primary" className="hrm-btn hrm-btn-success" icon={<PlusOutlined />} onClick={onMoModalThemNhanSu}>Thêm nhân sự khác</Button>
                        )}
                        {!isDaDuyet && (
                            <Button type="primary" icon={<SendOutlined />} onClick={() => setIsShowModalDuyet(true)}>Xác nhận</Button>
                        )}
                        {!isDaDuyet && (
                            <Button className="hrm-btn hrm-btn-warning" icon={<SaveOutlined />} onClick={handleLuu}>Lưu</Button>
                        )}
                        <Button type="default" icon={<DownloadOutlined />} onClick={handleExport}>Xuất Excel</Button>
                    </Space>
                </Col>
            </Row>

            {/* Dữ liệu tham chiếu */}
            <Row gutter={8} className="form-group">
                <Col xs={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>Dữ liệu tham chiếu</div>
                            {!isDaDuyet && (
                                <Button type="primary" size="small" icon={<EditOutlined />} onClick={onMoModalCapNhatThamChieu}>
                                    Cập nhật
                                </Button>
                            )}
                        </div>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Khen thưởng/Ủng hộ</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongKhenThuongUngHo)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Phát sinh tính thuế</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdPhatSinhTinhThue)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương cơ bản</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongCoBan)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Phụ cấp</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongPhuCap)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương thêm giờ</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongThemGio)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương HTNV</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongHTNV)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Lương bổ sung Trưởng BKS</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongBSTBKS)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Thù lao không chuyên trách</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongThuLaoKCT)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Phụ cấp tổ giúp việc</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdLuongPhuCapTGV)}</div>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Bảo hiểm xã hội</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdBHXH)}</div>
                            </Col>
                            {thueThangInfo?.loaiChuKy === loaiChuKyThue.quy && (
                                <Col xs={24} sm={12} md={6}>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Thuế đã tạm thu</div>
                                    <div style={{ fontSize: '13px', marginTop: '5px' }}>{demSoKhoan(thueThangInfo?.dsIdThueTamTinh)}</div>
                                </Col>
                            )}
                        </Row>
                    </div>
                </Col>
            </Row>

            {/* Thống kê tổng */}
            <Row gutter={8} className="form-group">
                <Col xs={24} sm={12} md={12}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Tổng thuế phải nộp</div>
                        <div className="text-bold text-center">
                            {formatVND(danhSachChiTiet.reduce((s, x) => s + (x.thuePhaiNop ?? 0), 0))}
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Trạng thái</div>
                        <div className="text-bold text-center">
                            {thueThangInfo?.trangThai === 1 && <Tag color="orange">Khởi tạo</Tag>}
                            {thueThangInfo?.trangThai === 3 && <Tag color="green">Đã xác nhận</Tag>}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Bảng danh sách chi tiết */}
            <Row gutter={8}>
                <Col xs={24}>
                    <div className="card card-primary">
                        <Tabs
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: 'Chi tiết thuế TNCN',
                                    children: (() => {
                                        const headers = thueThangInfo?.dynamicColumnHeaders ?? [];
                                        const thuNhapCols = headers.filter(h => h.nhomCot === 0);
                                        const giamTruBHCols = headers.filter(h => h.nhomCot === 1);

                                        const columns: any[] = [
                                            {
                                                title: 'STT',
                                                key: 'stt',
                                                width: 50,
                                                align: 'center' as const,
                                                fixed: 'left' as const,
                                                render: (_: any, __: any, idx: number) => idx + 1,
                                            },
                                            {
                                                title: 'Họ và tên',
                                                dataIndex: 'hoTen',
                                                key: 'hoTen',
                                                width: 200,
                                                fixed: 'left' as const,
                                            },
                                            {
                                                title: 'Chức vụ',
                                                dataIndex: 'tenChucVu',
                                                key: 'tenChucVu',
                                                fixed: 'left' as const,
                                                width: 180,
                                            },
                                            {
                                                title: 'Thu nhập chịu thuế',
                                                children: [
                                                    ...thuNhapCols.map(h => ({
                                                        title: h.name,
                                                        key: `salary_${h.loai}_${h.id}`,
                                                        width: 150,
                                                        align: 'right' as const,
                                                        render: (_: any, row: ChiTietThueThangItem) =>
                                                            formatVND(row.dynamicColumns?.[`salary_${h.loai}_${h.id}`] ?? 0),
                                                    }))
                                                ],
                                            },
                                            {
                                                title: 'Thu nhập chịu thuế',
                                                dataIndex: 'thuNhapChiuThue',
                                                key: 'thuNhapChiuThue',
                                                width: 150,
                                                align: 'right' as const,
                                                render: (v: number) => formatVND(v),
                                            },
                                            {
                                                title: 'Các khoản giảm trừ',
                                                children: [
                                                    {
                                                        title: 'Bản thân',
                                                        key: 'giamTruBanThan',
                                                        dataIndex: 'giamTruBanThan',
                                                        width: 130,
                                                        align: 'right' as const,
                                                        render: (v: number) => formatVND(v),
                                                    },
                                                    {
                                                        title: 'Phụ thuộc',
                                                        key: 'giamTruNguoiPhuThuoc',
                                                        dataIndex: 'giamTruNguoiPhuThuoc',
                                                        width: 130,
                                                        align: 'right' as const,
                                                        render: (v: number) => formatVND(v),
                                                    },
                                                    {
                                                        title: 'Số người phụ thuộc',
                                                        key: 'soNguoiPhuThuoc',
                                                        dataIndex: 'soNguoiPhuThuoc',
                                                        width: 120,
                                                        align: 'center' as const,
                                                        render: (v: number) => v,
                                                    },
                                                    ...(giamTruBHCols.length > 0 ? [{
                                                        title: 'Các khoản BH phải nộp',
                                                        children: giamTruBHCols.map(h => ({
                                                            title: h.name,
                                                            key: `salary_${h.loai}_${h.id}`,
                                                            width: 150,
                                                            align: 'right' as const,
                                                            render: (_: any, row: ChiTietThueThangItem) =>
                                                                formatVND(row.dynamicColumns?.[`salary_${h.loai}_${h.id}`] ?? 0),
                                                        })),
                                                    }] : []),
                                                    {
                                                        title: 'Tổng cộng',
                                                        dataIndex: 'tongCongGiamTru',
                                                        key: 'tongCongGiamTru',
                                                        width: 150,
                                                        align: 'right' as const,
                                                        render: (v: number) => formatVND(v),
                                                    },
                                                    {
                                                        title: 'TNCT trả cho cá nhân thuộc diện khấu trừ thuế',
                                                        dataIndex: 'thuNhapTraChoCaNhan',
                                                        key: 'thuNhapTraChoCaNhan',
                                                        width: 170,
                                                        align: 'right' as const,
                                                        render: (v: number) => formatVND(v),
                                                    },
                                                ],
                                            },
                                            {
                                                title: 'Thu nhập tính thuế TNCN',
                                                dataIndex: 'thuNhapTinhThue',
                                                key: 'thuNhapTinhThue',
                                                width: 150,
                                                align: 'right' as const,
                                                render: (v: number) => formatVND(v),
                                            },
                                            {
                                                title: 'Thuế TNCN phải nộp',
                                                dataIndex: 'thuePhaiNop',
                                                key: 'thuePhaiNop',
                                                width: 150,
                                                align: 'right' as const,
                                                render: (v: number) => formatVND(v),
                                            },
                                            {
                                                title: 'Thuế đã tạm thu',
                                                dataIndex: 'thueDaNop',
                                                key: 'thueDaNop',
                                                width: 150,
                                                align: 'right' as const,
                                                render: (v: number) => formatVND(v),
                                            },
                                            {
                                                title: 'Thuế còn phải nộp',
                                                dataIndex: 'thueConPhaiNop',
                                                key: 'thueConPhaiNop',
                                                width: 150,
                                                align: 'right' as const,
                                                render: (v: number) => formatVND(v),
                                            },
                                            {
                                                title: 'Ghi chú',
                                                key: 'ghiChu',
                                                dataIndex: 'ghiChu',
                                                width: 150,
                                                render: (v: string) => v || '',
                                            },
                                            ...(!isDaDuyet ? [{
                                                title: 'Thao tác',
                                                key: 'action',
                                                width: 90,
                                                align: 'center' as const,
                                                fixed: 'right' as const,
                                                render: (_: any, record: ChiTietThueThangItem, index: number) => (
                                                    <Space size="small">
                                                        {record.loaiNhanSu !== 1 && <Button
                                                            type="link"
                                                            icon={<EditOutlined />}
                                                            style={{ padding: 0, color: '#1890ff' }}
                                                            title="Sửa"
                                                            onClick={() => onMoModalSuaNhanSu(record, index)}
                                                        />}
                                                        {record.loaiNhanSu !== 1 && (
                                                            <Popconfirm
                                                                title="Bạn có chắc muốn xóa nhân sự này khỏi bảng tính thuế?"
                                                                onConfirm={() => handleXoaNhanSu(index)}
                                                                okText="Xóa"
                                                                cancelText="Hủy"
                                                            >
                                                                <Button
                                                                    type="link"
                                                                    danger
                                                                    icon={<DeleteOutlined />}
                                                                    style={{ padding: 0 }}
                                                                    title="Xóa"
                                                                />
                                                            </Popconfirm>
                                                        )}
                                                    </Space>
                                                ),
                                            }] : []),
                                        ];

                                        return (
                                            <div className="card card-primary">
                                                <Table
                                                    sticky
                                                    columns={columns}
                                                    dataSource={(danhSachHienThi || []).map((value, index) => ({ key: index, ...value }))}
                                                    loading={isLoading}
                                                    bordered
                                                    scroll={{ x: 'max-content' }}
                                                    pagination={false}
                                                    locale={{ emptyText: 'Không có dữ liệu' }}
                                                    summary={pageData => {
                                                        let totalThuNhapChiuThue = 0;
                                                        let totalTongCongGiamTru = 0;
                                                        let totalThuNhapTraChoCaNhan = 0;
                                                        let totalThuNhapTinhThue = 0;
                                                        let totalThuePhaiNop = 0;
                                                        let totalThueDaNop = 0;
                                                        let totalThueConPhaiNop = 0;
                                                        pageData.forEach(row => {
                                                            totalThuNhapChiuThue += row.thuNhapChiuThue || 0;
                                                            totalTongCongGiamTru += row.tongCongGiamTru || 0;
                                                            totalThuNhapTraChoCaNhan += row.thuNhapTraChoCaNhan || 0;
                                                            totalThuNhapTinhThue += row.thuNhapTinhThue || 0;
                                                            totalThuePhaiNop += row.thuePhaiNop || 0;
                                                            totalThueDaNop += row.thueDaNop || 0;
                                                            totalThueConPhaiNop += row.thueConPhaiNop || 0;
                                                        });
                                                        const fixedBefore = 3;
                                                        const thuNhapDynCount = thuNhapCols.length;
                                                        const bhDynCount = giamTruBHCols.length;
                                                        const idxHop = fixedBefore + thuNhapDynCount;
                                                        const idxTongGiamTru = idxHop + 1 + 3 + bhDynCount;
                                                        const idxTNCT = idxTongGiamTru + 1;
                                                        const idxThuNhapTinhThue = idxTNCT + 1;
                                                        const idxThuePhaiNop = idxThuNhapTinhThue + 1;
                                                        const idxThueDaNop = idxThuePhaiNop + 1;
                                                        const idxThueConPhaiNop = idxThueDaNop + 1;
                                                        const idxGhiChu = idxThueConPhaiNop + 1;
                                                        const idxAction = idxGhiChu + 1;

                                                        return (
                                                            <Table.Summary.Row>
                                                                <Table.Summary.Cell index={0} colSpan={fixedBefore} align="left">
                                                                    <strong>Tổng cộng</strong>
                                                                </Table.Summary.Cell>
                                                                {thuNhapCols.map((_, ci) => (
                                                                    <Table.Summary.Cell key={ci} index={fixedBefore + ci} align="right" />
                                                                ))}
                                                                <Table.Summary.Cell index={idxHop} align="right">
                                                                    <strong>{formatVND(totalThuNhapChiuThue)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxHop + 1} align="right" />
                                                                <Table.Summary.Cell index={idxHop + 2} align="right" />
                                                                <Table.Summary.Cell index={idxHop + 3} align="center" />
                                                                {giamTruBHCols.map((_, ci) => (
                                                                    <Table.Summary.Cell key={ci} index={idxHop + 4 + ci} align="right" />
                                                                ))}
                                                                <Table.Summary.Cell index={idxTongGiamTru} align="right">
                                                                    <strong>{formatVND(totalTongCongGiamTru)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxTNCT} align="right">
                                                                    <strong>{formatVND(totalThuNhapTraChoCaNhan)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxThuNhapTinhThue} align="right">
                                                                    <strong>{formatVND(totalThuNhapTinhThue)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxThuePhaiNop} align="right">
                                                                    <strong>{formatVND(totalThuePhaiNop)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxThueDaNop} align="right">
                                                                    <strong>{formatVND(totalThueDaNop)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxThueConPhaiNop} align="right">
                                                                    <strong>{formatVND(totalThueConPhaiNop)}</strong>
                                                                </Table.Summary.Cell>
                                                                <Table.Summary.Cell index={idxGhiChu} />
                                                                {!isDaDuyet && <Table.Summary.Cell index={idxAction} />}
                                                            </Table.Summary.Row>
                                                        );
                                                    }}
                                                />
                                            </div>
                                        );
                                    })(),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>


            <ModalTextForm
                show={isShowModalDuyet}
                title="Xác nhận thuế TNCN tháng"
                handleClose={() => setIsShowModalDuyet(false)}
                handleSave={handleDuyet}
            >
                Bạn có chắc muốn xác nhận thuế TNCN kỳ{' '}
                {thueThangInfo?.tenKyThue} không?
            </ModalTextForm>

            {isShowModalCapNhatThamChieu && (
                <ModalTextForm
                    title="Cập nhật dữ liệu tham chiếu"
                    hideFooter
                    show={isShowModalCapNhatThamChieu}
                    handleClose={() => setIsShowModalCapNhatThamChieu(false)}
                >
                    <Form layout="vertical" validateMessages={validateMessages} onFinish={onFinishCapNhatThamChieu} form={form}>
                        {thueThangInfo?.kieuTinh === kieuTinhThue.dieuChinh && (
                            <>
                                {
                                    renderThanhPhanRow("Kỳ tính thuế tạm tính", "idThueTamTinh", namLocThueTamTinh,
                                        taoOnChangeNamLoc(setNamLocThueTamTinh, "idThueTamTinh", setDsThueTamTinh, layDsThueThangTheoNam),
                                        optionsThueTamTinh)}
                            </>
                        )}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#1890ff', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập chịu thuế
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Lương cơ bản", "dsIdLuongCoBan", namLocLuongCoBan,
                            taoOnChangeNamLoc(setNamLocLuongCoBan, "dsIdLuongCoBan", setDsLuongCoBan, layDsLuongCoBanTheoNam),
                            optionsLuongCoBan)}

                        {renderThanhPhanRow("Phụ cấp", "dsIdLuongPhuCap", namLocLuongPhuCap,
                            taoOnChangeNamLoc(setNamLocLuongPhuCap, "dsIdLuongPhuCap", setDsLuongPhuCap, layDsBangLuongPhuCapTheoNam),
                            optionsLuongPhuCap)}

                        {renderThanhPhanRow("Lương thêm giờ", "dsIdLuongThemGio", namLocLuongThemGio,
                            taoOnChangeNamLoc(setNamLocLuongThemGio, "dsIdLuongThemGio", setDsLuongThemGio, layDsLuongThemGioTheoNam),
                            optionsLuongThemGio)}

                        {renderThanhPhanRow("Lương HTNV", "dsIdLuongHTNV", namLocLuongHTNV,
                            taoOnChangeNamLoc(setNamLocLuongHTNV, "dsIdLuongHTNV", setDsLuongHTNV, layDsLuongHoanThanhNhiemVuTheoNam),
                            optionsLuongHTNV)}

                        {renderThanhPhanRow("Bổ sung Trưởng BKS", "dsIdLuongBSTBKS", namLocLuongBSTBKS,
                            taoOnChangeNamLoc(setNamLocLuongBSTBKS, "dsIdLuongBSTBKS", setDsLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam),
                            optionsLuongBSTBKS)}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdLuongThuLaoKCT", namLocLuongThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocLuongThuLaoKCT, "dsIdLuongThuLaoKCT", setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam),
                            optionsLuongThuLaoKCT)}

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdLuongPhuCapTGV", namLocLuongPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocLuongPhuCapTGV, "dsIdLuongPhuCapTGV", setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam),
                            optionsLuongPhuCapTGV)}

                        {renderThanhPhanRow("Tăng thêm", "dsIdLuongTangThem", namLocLuongTangThem,
                            taoOnChangeNamLoc(setNamLocLuongTangThem, "dsIdLuongTangThem", setDsLuongTangThem, layDsKhenThuongUngHoTheoNam, (x) => x.loai === 1),
                            optionsLuongTangThem)}

                        {renderThanhPhanRow("Thu nhập phát sinh", "dsIdPhatSinhThuNhap", namLocPhatSinhThuNhap,
                            taoOnChangeNamLoc(setNamLocPhatSinhThuNhap, "dsIdPhatSinhThuNhap", setDsPhatSinhThuNhap, layDsPhatSinhTinhThueTheoNam, (x: any) => x.loai === 1),
                            optionsPhatSinhThuNhap)}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#ff4d4f', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập giảm trừ
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Bảo hiểm xã hội", "dsIdBHXH", namLocBHXH,
                            taoOnChangeNamLoc(setNamLocBHXH, "dsIdBHXH", setDsBHXH, layDsBaoHiemTheoNam),
                            optionsBaoHiem)}

                        {renderThanhPhanRow("Giảm trừ", "dsIdLuongGiamTru", namLocLuongGiamTru,
                            taoOnChangeNamLoc(setNamLocLuongGiamTru, "dsIdLuongGiamTru", setDsLuongGiamTru, layDsKhenThuongUngHoTheoNam, (x) => x.loai === 0),
                            optionsLuongGiamTru)}

                        {renderThanhPhanRow("Đóng góp khác", "dsIdPhatSinhGiamTru", namLocPhatSinhGiamTru,
                            taoOnChangeNamLoc(setNamLocPhatSinhGiamTru, "dsIdPhatSinhGiamTru", setDsPhatSinhGiamTru, layDsPhatSinhTinhThueTheoNam, (x: any) => x.loai === 0),
                            optionsPhatSinhGiamTru)}

                        {thueThangInfo?.loaiChuKy === loaiChuKyThue.quy &&
                            renderThanhPhanRow("Thuế đã tạm thu", "dsIdThueTamTinh", namLocThueTamTinh,
                                taoOnChangeNamLoc(setNamLocThueTamTinh, "dsIdThueTamTinh", setDsThueTamTinh, layDsThueThangTheoNam),
                                optionsThueTamTinh)}

                        <Form.Item>
                            <Button type="primary" className="float-right" htmlType="submit" icon={<SaveOutlined />}>
                                Cập nhật
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            {isShowModalNhanSuNgoai && (
                <ModalTextForm
                    title={editingIndex !== null ? "Chỉnh sửa thông tin nhân sự tính thuế" : "Thêm nhân sự khác tính thuế"}
                    hideFooter
                    show={isShowModalNhanSuNgoai}
                    handleClose={() => setIsShowModalNhanSuNgoai(false)}
                >
                    <Form
                        layout="vertical"
                        form={formNhanSuNgoai}
                        onValuesChange={recalculateModalFields}
                        onFinish={onFinishNhanSuNgoai}
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label="Họ và tên"
                                    name="hoTen"
                                    rules={[{ required: true, message: 'Vui lòng nhập họ và tên' }]}
                                >
                                    <AutoComplete
                                        options={optionsNhanSuKhac}
                                        placeholder="Nhập hoặc chọn nhân sự..."
                                        filterOption={(inputValue, option) =>
                                            (option?.label ?? '').toString().toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        onSelect={(value, option: any) => {
                                            if (option?.item) {
                                                formNhanSuNgoai.setFieldsValue({
                                                    hoTen: option.item.hoTen,
                                                    tenChucVu: option.item.tenChucVu || '',
                                                    idNhom: option.item.idNhomNhanSu || 6,
                                                });
                                            }
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Chức vụ / Công việc" name="tenChucVu">
                                    <Input placeholder="Ví dụ: Tạp vụ, Lái xe, Hợp đồng..." />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Nhóm nhân sự" name="idNhom">
                                    <Select
                                        placeholder="Chọn nhóm nhân sự"
                                        options={optionsNhomNhanSu}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Ghi chú" name="ghiChu">
                                    <Input placeholder="Ghi chú thêm nếu có" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" style={{ margin: '8px 0 12px 0' }}>
                            <span style={{ color: '#1890ff', fontSize: '14px', fontWeight: 'bold' }}>
                                Thu nhập chịu thuế & Trả cá nhân
                            </span>
                        </Divider>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Thu nhập chịu thuế" name="thuNhapChiuThue">
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                        placeholder="Nhập thu nhập chịu thuế"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="TNCT trả cho cá nhân thuộc diện khấu trừ thuế" name="thuNhapTraChoCaNhan">
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                        placeholder="Mặc định bằng TN chịu thuế"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" style={{ margin: '8px 0 12px 0' }}>
                            <span style={{ color: '#ff4d4f', fontSize: '14px', fontWeight: 'bold' }}>
                                Các khoản giảm trừ
                            </span>
                        </Divider>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label={`Giảm trừ bản thân (Định mức: ${formatVND(15500000 * soThang)})`}
                                    name="giamTruBanThan"
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Số người phụ thuộc" name="soNguoiPhuThuoc">
                                    <InputNumber
                                        min={0}
                                        style={{ width: '100%' }}
                                        placeholder="Số người phụ thuộc"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item
                                    label={`Giảm trừ NPT (Định mức: ${formatVND(6200000 * soThang)}/người)`}
                                    name="giamTruNguoiPhuThuoc"
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Bảo hiểm / Giảm trừ khác" name="giamTruKhac">
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={12}>
                            <Col span={24}>
                                <Form.Item label="Tổng cộng giảm trừ" name="tongCongGiamTru">
                                    <InputNumber
                                        disabled
                                        style={{ width: '100%', color: '#000', fontWeight: 'bold' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" style={{ margin: '8px 0 12px 0' }}>
                            <span style={{ color: '#52c41a', fontSize: '14px', fontWeight: 'bold' }}>
                                Tính thuế TNCN (Tự động)
                            </span>
                        </Divider>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Thu nhập tính thuế TNCN" name="thuNhapTinhThue">
                                    <InputNumber
                                        disabled
                                        style={{ width: '100%', color: '#000', fontWeight: 'bold' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Thuế TNCN phải nộp" name="thuePhaiNop">
                                    <InputNumber
                                        disabled
                                        style={{ width: '100%', color: '#cf1322', fontWeight: 'bold' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item label="Thuế đã tạm thu" name="thueDaNop">
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => Number(value?.replace(/\$\s?|(,*)/g, '') || 0)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Thuế còn phải nộp" name="thueConPhaiNop">
                                    <InputNumber
                                        disabled
                                        style={{ width: '100%', color: '#cf1322', fontWeight: 'bold' }}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item style={{ marginBottom: 0, marginTop: 12 }}>
                            <Space className="float-right">
                                <Button onClick={() => setIsShowModalNhanSuNgoai(false)}>Hủy</Button>
                                <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                                    {editingIndex !== null ? "Lưu thay đổi" : "Thêm vào bảng"}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}
        </section>
    );
};

export default ThueTNCN;
